<template>
  <div class="admin-page">
    <div class="admin-toolbar">
      <div class="admin-toolbar__actions">
        <el-input
          v-model="filters.toEmail"
          placeholder="收件人邮箱"
          clearable
          class="filter-input-wide"
          @keyup.enter="reload"
        />
        <el-select v-model="filters.templateType" placeholder="场景" clearable class="filter-select" @change="reload">
          <el-option label="全部场景" value="" />
          <el-option label="注册验证码" value="register" />
          <el-option label="找回密码" value="forget" />
          <el-option label="登录验证码" value="login" />
          <el-option label="组织邀请" value="invite" />
          <el-option label="停机通知" value="stop_instance" />
        </el-select>
        <el-select v-model="filters.status" placeholder="状态" class="filter-select" @change="reload">
          <el-option label="全部状态" :value="0" />
          <el-option label="成功" :value="1" />
          <el-option label="失败" :value="2" />
        </el-select>
        <el-button type="primary" @click="reload">查询</el-button>
      </div>
    </div>

    <el-table :data="logs" v-loading="loading" style="width: 100%">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="toEmail" label="收件人" min-width="180" show-overflow-tooltip />
      <el-table-column prop="subject" label="主题" min-width="180" show-overflow-tooltip />
      <el-table-column label="场景" width="120">
        <template #default="scope">{{ sceneLabel(scope.row.templateType) }}</template>
      </el-table-column>
      <el-table-column label="状态" width="90">
        <template #default="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" size="small">
            {{ scope.row.status === 1 ? '成功' : '失败' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="errorMessage" label="错误信息" min-width="200" show-overflow-tooltip>
        <template #default="scope">{{ scope.row.errorMessage || '—' }}</template>
      </el-table-column>
      <el-table-column prop="clientIp" label="IP" width="140" />
      <el-table-column prop="userId" label="用户ID" width="90" />
      <el-table-column label="时间" width="180">
        <template #default="scope">{{ formatTime(scope.row.createdAt) }}</template>
      </el-table-column>
    </el-table>

    <AdminPagination
      v-model:current-page="page"
      v-model:page-size="pageSize"
      :total="total"
      @size-change="loadLogs"
      @current-change="loadLogs"
    />
  </div>
</template>

<script>
import axios from 'axios'
import AdminPagination from '@/components/AdminPagination.vue'
import { authHeaders } from '@/utils/http'

const SCENE_LABELS = {
  register: '注册验证码',
  forget: '找回密码',
  login: '登录验证码',
  invite: '组织邀请',
  stop_instance: '停机通知',
  other: '其他'
}

export default {
  name: 'AdminEmailSendLogView',
  components: { AdminPagination },
  data() {
    return {
      loading: false,
      logs: [],
      total: 0,
      page: 1,
      pageSize: 20,
      filters: {
        toEmail: '',
        templateType: '',
        status: 0
      }
    }
  },
  created() {
    this.loadLogs()
  },
  methods: {
    sceneLabel(scene) {
      return SCENE_LABELS[scene] || scene || '—'
    },
    formatTime(ts) {
      if (!ts) return '—'
      return new Date(ts * 1000).toLocaleString()
    },
    reload() {
      this.page = 1
      this.loadLogs()
    },
    async loadLogs() {
      this.loading = true
      try {
        const res = await axios.post(
          '/api/v1/admin/email/send-log/list',
          {
            page: this.page,
            pageSize: this.pageSize,
            toEmail: this.filters.toEmail || undefined,
            templateType: this.filters.templateType || undefined,
            status: this.filters.status || 0
          },
          { headers: authHeaders() }
        )
        if (res.data.code !== 200) {
          this.$message.error(res.data.message || '加载失败')
          return
        }
        this.logs = res.data.data?.logs || []
        this.total = res.data.data?.total || 0
      } catch (e) {
        this.$message.error(e.response?.data?.message || '加载邮件日志失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.filter-input-wide {
  width: 220px;
}
</style>
